import React from "react";

// Material UI
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Paper from "@mui/material/Paper";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import FilterListIcon from "@mui/icons-material/FilterList";

// Components
import AutocompleteBolean from "../../../components/inputs/autocompletes/autocompleteBolean";
import Dropdown from "../../../components/inputs/dropdown";
import Searchbox from "../../../components/inputs/searchbox";

// Hooks
import useCountries from "../../../hooks/countries/useCountries";
import useUser from '../../../hooks/user/useUser';

// Models
import { GetDocumentTypeByCountry, GetConditionTypeByCountry } from "../../../models/EnumEntity";

const CustomerFilters = ({ filters, setFilters, clearFilters }) => {
    const { countries, loading: loadingCountries } = useCountries();
    const { branch } = useUser();

    const handleFilterChange = (event) =>
        setFilters({
            ...filters,
            [event.target.name]: event.target.value,
        });

    const handleAutoCompleteChange = (event, option, name) => {
        setFilters({
            ...filters,
            pageNumber: 1,
            [name]: option?.value
        });
    }

    return (
        <Box component={Paper} paddingX={2} paddingY={2}>
            <Grid container spacing={1}>
                <Grid size={12}>
                    <Typography variant="inherit" color="primary">
                        Filtrar por cliente:
                    </Typography>
                </Grid>
                <Grid
                    size={{
                        xs: 12,
                        sm: 2
                    }}
                >
                    <Dropdown
                        fullWidth
                        name="documentType"
                        onChange={handleFilterChange}
                        size="small"
                        label="Tipo de documento"
                        getOptionLabel={(option) => option?.label}
                        getOptionValue={(option) => option?.value}
                        value={filters?.documentType || ""}
                        values={GetDocumentTypeByCountry(branch?.country)}
                    />
                </Grid>
                <Grid
                    size={{
                        xs: 12,
                        sm: 3
                    }}
                >
                    <Searchbox
                        fullWidth
                        size="small"
                        name="documentNumber"
                        label="Nro. de documento"
                        onChange={handleFilterChange}
                        value={filters?.documentNumber || ""}
                    />
                </Grid>
                <Grid
                    size={{
                        xs: 12,
                        sm: 3
                    }}
                >
                    <Dropdown
                        fullWidth
                        name="taxCondition"
                        onChange={handleFilterChange}
                        size="small"
                        label="Condicion"
                        getOptionLabel={(option) => option?.label}
                        getOptionValue={(option) => option?.value}
                        value={filters?.taxCondition || ""}
                        values={GetConditionTypeByCountry(branch?.country)}
                    />
                </Grid>
                <Grid
                    size={{
                        xs: 12,
                        sm: 4
                    }}
                >
                    <Searchbox
                        fullWidth
                        size="small"
                        name="email"
                        label="Email"
                        onChange={handleFilterChange}
                        value={filters?.email || ""}
                    />
                </Grid>
                <Grid
                    size={{
                        xs: 12,
                        sm: 3
                    }}
                >
                    <Searchbox
                        fullWidth
                        size="small"
                        name="name"
                        label="Nombre"
                        onChange={handleFilterChange}
                        value={filters?.name || ""}
                    />
                </Grid>
                <Grid
                    size={{
                        xs: 12,
                        sm: 3
                    }}
                >
                    <Searchbox
                        fullWidth
                        size="small"
                        name="lastName"
                        label="Apellido"
                        onChange={handleFilterChange}
                        value={filters?.lastName || ""}
                    />
                </Grid>
                <Grid
                    size={{
                        xs: 12,
                        sm: 2
                    }}
                >
                    <Dropdown
                        fullWidth
                        name="country"
                        onChange={handleFilterChange}
                        size="small"
                        label="Pais"
                        loading={loadingCountries}
                        getOptionLabel={(option) => option?.name}
                        getOptionValue={(option) => option?.isoAlpha2Code}
                        value={filters?.country || ""}
                        values={countries}
                    />
                </Grid>
                <Grid
                    size={{
                        xs: 12,
                        sm: 2
                    }}
                >
                    <AutocompleteBolean
                        name="active"
                        onChange={handleAutoCompleteChange}
                        size="small"
                        label="Activo"
                        value={filters?.active?.toString() || ""}
                    />
                </Grid>
                <Grid
                    container
                    alignContent="flex-end"
                    size={{
                        xs: 12,
                        sm: 2,
                        md: 2
                    }}
                >
                    <Button
                        fullWidth
                        color="primary"
                        variant="outlined"
                        onClick={clearFilters}
                        startIcon={<FilterListIcon />}
                    >
                        Limpiar
                    </Button>
                </Grid>
            </Grid>
        </Box>
    );
};

export default CustomerFilters;
